import { Stack } from "@mui/material"
import {Link} from 'react-router-dom'

import {logo} from './utils/constant'
import SearchBar from "./SearchBar"

const Navbar = () => (  
    <Stack direction="row" 
    alignItems="center"
     p={5} sx={{ position: 'sticky', background: "#000", top: 0, justifyContent: "space-between" }}>
     <Link to="/" style={{display: "flex-start", alignItems:"Center"}}>
    <img src={logo} alt="logo" height={30}/>
     </Link> 
       <SearchBar />
    </Stack>
  )


export default Navbar
